<template>
    <Modal ref="modal" class="add-prepared-product-modal" @closed="onModalClose">
        <template #header="sp">
            <div class="h3">Ajouter un produit préparé non commandé</div>
        </template>
        <template #body="sp">
            <div class="form-group row">
                <label for="staticCustomerName" class="col-4 col-form-label">{{ customerTypeLabel }}</label>
                <div class="col-8">
                    <input type="text" readonly class="form-control-plaintext" id="staticCustomerName" :value="customerName">
                </div>
            </div>

            <div class="form-group row">
                <label for="staticDeliveryDate" class="col-4 col-form-label">Date de livraison</label>
                <div class="col-8">
                    <input type="text" readonly class="form-control-plaintext" id="staticDeliveryDate" :value="formatDate(pageData.order.delivery_date)">
                </div>
            </div>

            <SearchProductForm placeholder="Rechercher un produit" @selected="onSelectProduct" />

            <PreparationProduct
                class="mt-2"
                v-if="selectedProduct"
                :order="pageData.order"
                :product="selectedProduct"
                :preparation-status="selectedProductEntry.preparation_status"
                :inputs="selectedProductEntry.inputs"
                :cancellation-reasons="pageData.cancellationReasons"
                :display-subcustomers="pageData.displaySubcustomers"
                :subcustomers-orders="pageData.order.subcustomers && pageData.order.subcustomers.length ? $parent.subcustomersByProduct(selectedProduct.sku) : []"
                :read-only="!pageData.order.ready_to_prepare"
            >
                {{ selectedProduct.tiny_name }}
            </PreparationProduct>
        </template>
        <template #footer>
            <button class="btn btn-secondary" @click="closeModal">
                Fermer
            </button>
        </template>
    </Modal>
</template>

<script>
    import AuthorizationModal from "../AuthorizationModal";
    import AuthorizationModalButton from "../AuthorizationModalButton";
    import ErrorsZone from "../ErrorsZone";
    import Modal from "../Modal";
    import PreparationProduct from "./PreparationProduct";
    import SearchProductForm from "../SearchProductForm";

    export default {
        name: 'AddPreparedProductModal',

        components: {
            AuthorizationModal,
            AuthorizationModalButton,
            ErrorsZone,
            Modal,
            PreparationProduct,
            SearchProductForm,
        },

        props: {
            productsEntriesBySku: {
                type: Object,
                required: true,
            },
            pageData: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                selectedProduct: null,
            };
        },

        methods: {
            showModal() {
                this.$refs.modal.showModal();
            },

            closeModal() {
                this.$refs.modal.closeModal();
            },

            formatDate(date) {
                return moment(date).format('dddd D MMMM Y')
            },

            onModalClose() {
                this.selectedProduct = null;
            },

            onSelectProduct(product) {
                this.selectedProduct = product;
            },
        },

        computed: {
            selectedProductEntry() {
                return this.productsEntriesBySku[this.selectedProduct.sku] || {
                    inputs: [],
                    offered_weight: null,
                    preparation_status: {
                        color: 'gray',
                        denominator: 0,
                        numerator: 0,
                        preparation_counters: {
                            nb_accounted: 0,
                            nb_missing: 0,
                            nb_offered: 0,
                            nb_ordered: 0,
                            nb_pending: 0,
                            nb_prepared: 0,
                            nb_surplus: 0,
                            nb_toremove: 0,
                        },
                    },
                    prepared_weight: null,
                    product: this.selectedProduct,
                    subcustomers: [],
                };
            },

            customerName() {
                if (this.pageData.order.subcustomer) {
                    return this.pageData.order.subcustomer.name;
                }
                return this.pageData.order.customer.name;
            },

            customerTypeLabel() {
                switch (this.pageData.order.customer.type) {
                    case 'store':
                        return 'Magasin';
                    case 'short_channel':
                        return 'Circuit court';
                    case 'customer_group':
                        return 'Groupement de clients';
                    case 'pickup_point':
                        return 'Lieu de retrait';
                    default:
                        return 'Client';
                }
            },
        },
    }
</script>

<style lang="scss">
    .add-prepared-product-modal {
        :first-of-type(.modal-container) {
            max-width: 600px;
            width: auto;
        }
        .modal-body {
            overflow: visible;
        }
    }
</style>
